// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .case {
  background-color: #f6f3f3;
  padding-left: 20px;
}
.theme-light .case .images {
  width: 100%;
  height: 300px;
  position: relative;
}
.theme-light .case .images .cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.theme-light .case .images .casePic {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 200px;
}
.theme-light .case .caseContainer {
  padding: 20px 70px;
}
@media (max-width: 480px) {
  .theme-light .case .caseContainer {
    padding: 10px;
  }
}
@media (max-width: 960px) {
  .theme-light .case .caseContainer {
    padding: 20px;
  }
}
.theme-light .case .caseContainer .cInfo {
  box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);
  border-radius: 20px;
  background-color: white;
  color: #000;
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
@media (max-width: 480px) {
  .theme-light .case .caseContainer .cInfo {
    flex-direction: column;
    height: 30vh;
    padding: 20px;
    margin-top: 100px;
  }
}
.theme-light .case .caseContainer .cInfo .center {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.theme-light .case .caseContainer .cInfo .center span {
  font-size: 30px;
  font-weight: 500;
}
.theme-light .case .caseContainer .cInfo .center .caseName {
  font-size: xx-large;
  font-weight: 500;
  border-radius: 20%;
  padding: 5px;
  background-color: #f6f3f3;
  z-index: 99;
}
.theme-light .case .caseContainer .cInfo .center .info {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.theme-light .case .caseContainer .cInfo .center .info .item {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #555;
}
.theme-light .case .caseContainer .cInfo .center .info .item span {
  font-size: 12px;
}
.theme-light .case .caseContainer .cInfo .center button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-light .case .caseContainer .cInfo .right button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-light .case .caseContainer .cInfo .osintDropDownMenu {
  position: relative;
}
.theme-light .case .caseContainer .cInfo .osintDropDownMenu .menuOption {
  cursor: pointer;
}
.theme-light .case .caseContainer .cInfo .caseButtons {
  flex: 1 1;
  display: flex;
  gap: 10px;
  align-items: center;
}
@media (max-width: 960px) {
  .theme-light .case .caseContainer .cInfo .caseButtons {
    flex-wrap: wrap;
  }
}
.theme-light .case .caseContainer .cInfo .caseButtons button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-light .case .caseContainer .cInfo .caseButtons .dropdownMenu {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 150px;
  padding-left: 18px;
  padding-bottom: 20px;
  flex-direction: column;
  background-color: white;
  color: #000;
  position: absolute;
  top: 40px;
  left: -50px;
}
.theme-light .case .caseContainer .cInfo .caseButtons .caseButton {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-light .case .caseContainer .cInfo .caseButtons a {
  color: #555;
}
.theme-dark .case {
  background-color: #333;
  padding-left: 20px;
}
.theme-dark .case .images {
  width: 100%;
  height: 300px;
  position: relative;
}
.theme-dark .case .images .cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.theme-dark .case .images .casePic {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 200px;
}
.theme-dark .case .caseContainer {
  padding: 20px 70px;
}
@media (max-width: 480px) {
  .theme-dark .case .caseContainer {
    padding: 10px;
  }
}
@media (max-width: 960px) {
  .theme-dark .case .caseContainer {
    padding: 20px;
  }
}
.theme-dark .case .caseContainer .cInfo {
  box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);
  border-radius: 20px;
  background-color: #222;
  color: #fffef9;
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
@media (max-width: 480px) {
  .theme-dark .case .caseContainer .cInfo {
    flex-direction: column;
    height: 30vh;
    padding: 20px;
    margin-top: 100px;
  }
}
.theme-dark .case .caseContainer .cInfo .center {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.theme-dark .case .caseContainer .cInfo .center span {
  font-size: 30px;
  font-weight: 500;
}
.theme-dark .case .caseContainer .cInfo .center .caseName {
  font-size: xx-large;
  font-weight: 500;
  border-radius: 20%;
  padding: 5px;
  background-color: #333;
  z-index: 99;
}
.theme-dark .case .caseContainer .cInfo .center .info {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.theme-dark .case .caseContainer .cInfo .center .info .item {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #d1d0c9;
}
.theme-dark .case .caseContainer .cInfo .center .info .item span {
  font-size: 12px;
}
.theme-dark .case .caseContainer .cInfo .center button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-dark .case .caseContainer .cInfo .right button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-dark .case .caseContainer .cInfo .osintDropDownMenu {
  position: relative;
}
.theme-dark .case .caseContainer .cInfo .osintDropDownMenu .menuOption {
  cursor: pointer;
}
.theme-dark .case .caseContainer .cInfo .caseButtons {
  flex: 1 1;
  display: flex;
  gap: 10px;
  align-items: center;
}
@media (max-width: 960px) {
  .theme-dark .case .caseContainer .cInfo .caseButtons {
    flex-wrap: wrap;
  }
}
.theme-dark .case .caseContainer .cInfo .caseButtons button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-dark .case .caseContainer .cInfo .caseButtons .dropdownMenu {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 150px;
  padding-left: 18px;
  padding-bottom: 20px;
  flex-direction: column;
  background-color: #222;
  color: #fffef9;
  position: absolute;
  top: 40px;
  left: -50px;
}
.theme-dark .case .caseContainer .cInfo .caseButtons .caseButton {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-dark .case .caseContainer .cInfo .caseButtons a {
  color: #d1d0c9;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/pages/case/case.scss"],"names":[],"mappings":"AAqBI;ECjBA,yBAAA;EACA,kBAAA;AAFJ;AAGI;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AADN;AAGM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AADR;AAIM;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AAFR;AAKI;EACE,kBAAA;AAHN;ADgBE;ECdE;IAII,aAAA;EAFN;AACF;ADgBE;ECnBE;IAQI,aAAA;EADN;AACF;AAGM;EAIE,kDAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAFR;ADPE;ECHI;IAeI,sBAAA;IACA,YAAA;IACA,aAAA;IACA,iBAAA;EADR;AACF;AAIQ;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAFV;AAIU;EACE,eAAA;EACA,gBAAA;AAFZ;AAKU;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;AAHZ;AAOU;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AALZ;AAOY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AALd;AAOc;EACE,eAAA;AALhB;AASU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAPZ;AAcU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAZZ;AAgBQ;EACE,kBAAA;AAdV;AAeU;EACE,eAAA;AAbZ;AAgBQ;EACE,SAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAdV;ADxEE;ECkFM;IAOI,eAAA;EAbV;AACF;AAgBU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAdZ;AAiBU;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EAEA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACE,SAAA;EACA,WAAA;AAhBd;AAkBU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAhBZ;AAmBU;EACE,WAAA;AAjBZ;ADzII;ECjBA,sBAAA;EACA,kBAAA;AA6JJ;AA5JI;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AA8JN;AA5JM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA8JR;AA3JM;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AA6JR;AA1JI;EACE,kBAAA;AA4JN;AD/IE;ECdE;IAII,aAAA;EA6JN;AACF;AD/IE;ECnBE;IAQI,aAAA;EA8JN;AACF;AA5JM;EAIE,kDAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AA6JR;ADtKE;ECHI;IAeI,sBAAA;IACA,YAAA;IACA,aAAA;IACA,iBAAA;EA8JR;AACF;AA3JQ;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AA6JV;AA3JU;EACE,eAAA;EACA,gBAAA;AA6JZ;AA1JU;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;AA4JZ;AAxJU;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AA0JZ;AAxJY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AA0Jd;AAxJc;EACE,eAAA;AA0JhB;AAtJU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAwJZ;AAjJU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAmJZ;AA/IQ;EACE,kBAAA;AAiJV;AAhJU;EACE,eAAA;AAkJZ;AA/IQ;EACE,SAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAiJV;ADvOE;ECkFM;IAOI,eAAA;EAkJV;AACF;AA/IU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAiJZ;AA9IU;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EAEA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACE,SAAA;EACA,WAAA;AA+Id;AA7IU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AA+IZ;AA5IU;EACE,cAAA;AA8IZ","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.case {\n  @include themify($themes) {\n    background-color: themed(\"bgSoft\");\n    padding-left: 20px;\n    .images {\n      width: 100%;\n      height: 300px;\n      position: relative;\n\n      .cover {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n\n      .casePic {\n        width: 200px;\n        height: 200px;\n        border-radius: 50%;\n        object-fit: cover;\n        position: absolute;\n        left: 0;\n        right: 0;\n        margin: auto;\n        top: 200px;\n      }\n    }\n    .caseContainer {\n      padding: 20px 70px;\n\n      @include mobile{\n        padding: 10px;\n      }\n\n      @include tablet{\n        padding: 20px;\n      }\n\n      .cInfo {\n        // height: 180px;\n        -webkit-box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n        -moz-box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n        box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n        border-radius: 20px;\n        background-color: themed(\"bg\");\n        color: themed(\"textColor\");\n        padding: 50px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 20px;\n\n        @include mobile{\n          flex-direction: column;\n          height: 30vh;\n          padding: 20px;\n          margin-top: 100px;\n        }\n\n        \n        .center {\n          flex: 1;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          gap: 10px;\n\n          span {\n            font-size: 30px;\n            font-weight: 500;\n          }\n\n          .caseName {\n            font-size: xx-large;\n            font-weight: 500;\n            border-radius: 20%;\n            padding: 5px;\n            background-color: themed(\"bgSoft\");\n            z-index: 99;\n          }\n          \n\n          .info {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: space-around;\n\n            .item {\n              display: flex;\n              align-items: center;\n              gap: 5px;\n              color: themed(\"textColorSoft\");\n\n              span {\n                font-size: 12px;\n              }\n            }\n          }\n          button {\n            border: none;\n            background-color: #5271ff;\n            color: white;\n            padding: 10px 20px;\n            border-radius: 5px;\n            cursor: pointer;\n          }\n          \n        }\n\n\n        .right {\n          button {\n            border: none;\n            background-color: #5271ff;\n            color: white;\n            padding: 10px 20px;\n            border-radius: 5px;\n            cursor: pointer;\n          }\n        }\n        \n        .osintDropDownMenu {\n          position: relative;\n          .menuOption{\n            cursor: pointer;\n          }\n        }\n        .caseButtons {\n          flex: 1;\n          display: flex;\n          gap: 10px;\n          align-items: center;\n\n          @include tablet{\n            flex-wrap: wrap;\n          }\n\n\n          button {\n            border: none;\n            background-color: #5271ff;\n            color: white;\n            padding: 10px 20px;\n            border-radius: 5px;\n            cursor: pointer;\n          }\n\n          .dropdownMenu {\n            display: flex;\n            align-items: flex-start;\n            gap: 10px;\n            \n            width: 150px;\n            padding-left: 18px;\n            padding-bottom: 20px;\n            flex-direction: column;\n            background-color: themed(\"bg\");\n            color: themed(\"textColor\");\n            position: absolute;\n              top: 40px;\n              left: -50px;\n          }\n          .caseButton {\n            border: none;\n            background-color: #5271ff;\n            color: white;\n            padding: 10px 20px;\n            border-radius: 5px; \n            cursor: pointer;\n          }\n\n          a{\n            color: themed(\"textColorSoft\");\n          }\n        }\n\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
